import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const approvedAtFilter = ({
  expensesContext,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => ({
  type: FilterType.Date,
  categories: [
    {
      kind: 'DatePicker',
      operation: 'between',
    },
  ],
  onUpdateValue: () => {
    trackFilters('approved_at', expensesContext)
  },
  identifier: 'expensesList.approvedAtFilter',
  path: 'approvedAt',
  title: i18n.t('expenses_v2.list.header.approved_at'),
})

export default approvedAtFilter
